'use client'

import React from 'react'
import { AreaItem } from '@/types/cms/AreaItem'
import Icon from '@/services/components/strategies/common/Icon'

interface NavigationViewLinkProps {
  item: AreaItem
  onNavigate: (item: AreaItem) => void
}

const NavigationViewLink: React.FC<NavigationViewLinkProps> = ({
  item,
  onNavigate,
}) => {
  return (
    <button
      className="text-black font-bold text-base flex flex-row justify-between w-full py-2 items-center leading-4"
      onClick={() => onNavigate(item)}
    >
      <span>{item.title} </span>
      <Icon name="chevron-right" size={16} className=" text-gray-700" />
    </button>
  )
}

export default NavigationViewLink
